<template>
  <div :class="{ 'operate': !show }">
    <!-- 操作 -->
    <div :class="{ 'operate': show }">
      <!--全选  -->
      <el-checkbox v-model="checked" style="margin-right: 20px" @change="allChecked">
        {{ $t("message.allChecked") }}
      </el-checkbox>
      <!-- 再提一单 -->
      <el-button size="mini" type="primary" class="secondary" @click="raiseAnotherOrder" v-if="isAuth(154)">
        {{ $t("message.raiseAnotherOrder") }}
      </el-button>
      <!-- 提出新订单 -->
      <el-button size="mini" type="primary" class="secondary" @click="placeANewOrder" v-if="isAuth(154)">
        {{ $t("message.placeANewOrder") }}
      </el-button>
      <!-- 同ID商品 -->
      <el-button size="mini" type="primary" class="secondary" @click="sameID">
        {{ $t("message.productWithTheSameId") }}
      </el-button>
      <!-- 同店铺商品 -->
      <el-button size="mini" type="primary" class="secondary" @click="sameShop">
        {{ $t("message.sameStoreProduct") }}
      </el-button>
      <!-- 复制商品信息 -->
      <el-button size="mini" type="primary" class="dark" @click="copyText">
        {{ $t("message.copyProductInformation") }}
      </el-button>
      <!-- 加入商品库 -->
      <el-button size="mini" type="primary" class="secondary" @click="inventoryBatchSave" v-if="isAuth(566)">
        {{ $t("message.joinProductLibrary") }}
      </el-button>
      <!-- 加入商品管理：按选中商品的订单详情 ID 创建商品管理数据 -->
      <el-button size="mini" type="primary" class="secondary" @click="createProductManagement" v-if="isAuth(774)">
        {{ $t("message.joinProductManagement") }}
      </el-button>
      <!-- 交易号/物流号操作：与辅料操作统一收纳到下拉菜单中。 -->
      <el-dropdown
        v-if="isAuth(173) || isAuth(174) || isAuth(175) || isAuth(176) || isAuth(177)"
        trigger="hover"
        @command="handleTransactionLogisticsOperation"
      >
        <el-button size="mini" type="primary" class="orange">
          {{ $t("message.transactionLogisticsOperation") }}
        </el-button>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item v-if="isAuth(173)" command="transaction-split">
            {{ $t("message.transactionNumberSplit") }}
          </el-dropdown-item>
          <el-dropdown-item v-if="isAuth(174)" command="transaction-update">
            {{ $t("message.transactionNumberModification") }}
          </el-dropdown-item>
          <el-dropdown-item v-if="isAuth(175)" command="logistics-add">
            {{ $t("message.logisticsNumberAdded") }}
          </el-dropdown-item>
          <el-dropdown-item v-if="isAuth(176)" command="logistics-update">
            {{ $t("message.logisticsNumberModification") }}
          </el-dropdown-item>
          <el-dropdown-item v-if="isAuth(177)" command="logistics-delete">
            {{ $t("message.logisticsNumberDeleted") }}
          </el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
      <!-- 辅料操作 -->
      <el-dropdown v-if="isAuth(670) || isAuth(757)" trigger="hover" @command="handleMaterialOperation">
        <el-button size="mini" type="success" :disabled="materialSaving">
          {{ $t("message.materialOperation") }}
        </el-button>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item v-if="isAuth(670)" command="mark" :disabled="materialSaving || markMaterialDisabled">
            {{ $t("message.markAsMaterial") }}
          </el-dropdown-item>
          <el-dropdown-item v-if="isAuth(670)" command="cancel" :disabled="materialSaving">
            {{ $t("message.cancelMaterialMark") }}
          </el-dropdown-item>
          <el-dropdown-item v-if="isAuth(757)" command="bind" :disabled="materialSaving || bindMaterialDisabled">
            {{ $t("message.bindMaterialUsage") }}
          </el-dropdown-item>
          <el-dropdown-item command="create" :disabled="materialSaving">
            {{ $t('message.createMaterial') }}
          </el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
      <!-- 标签操作菜单 -->
      <el-dropdown trigger="hover" @command="handleTagOperation">
        <el-button size="mini" type="success">
          {{ $t("message.tagOperation") }}
        </el-button>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item command="batchDelete">{{ $t("message.batchDeleteLabels") }}</el-dropdown-item>
          <el-dropdown-item v-if="isAuth(230)" command="clearMatchData">{{ $t("message.clearFBAData") }}</el-dropdown-item>
          <el-dropdown-item v-if="isAuth(638)" command="copyCodeToText">{{ $t("message.codeCopyToText") }}</el-dropdown-item>
          <el-dropdown-item v-if="isAuth(232)" command="madeInChina">{{ $t("message.addMadeInChina") }}</el-dropdown-item>
          <el-dropdown-item v-if="isAuth(232)" command="orderLastFour" :disabled="appendingOrderLastFour">
            {{ $t('message.orderLastFour') }}
          </el-dropdown-item>
          <el-dropdown-item v-if="isAuth(232)" command="batchModifyCodeType">{{ $t("message.batchModifyBarcodeFormat") }}</el-dropdown-item>
          <el-dropdown-item command="add">{{ $t("message.labelNumberAdd") }}</el-dropdown-item>
          <el-dropdown-item v-if="isAuth(231)" command="tagMatching">{{ $t("message.tagMatching") }}</el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
      <el-button type="primary" size="small" @click="newEmergency">
        {{ $t('message.newEmergency') }}
      </el-button>
      <!-- 新增服务单 -->
      <el-button size="mini" type="success" @click="addServiceOrder" v-if="isAuth(766)">
        {{ $t("message.addServiceOrder") }}
      </el-button>
      <!-- 商品监控录入 -->
      <el-button size="mini" type="success" @click="commodityMonitoringEntry">
        {{ $t("message.commodityMonitoringEntry") }}
      </el-button>
      <!-- 预设任务 -->
      <el-button size="mini" type="primary" class="secondary" @click="createPresetTask">
        {{ $t("message.presetTask") }}
      </el-button>
      <!-- 商品信息录入 -->
      <el-button size="mini" type="primary" class="secondary" @click="commodityInformationEntry(1)" v-if="isAuth(727)">
        {{ $t("message.productInformationEntry") }}
      </el-button>
      <!-- 商品重量录入 -->
      <el-button size="mini" type="primary" class="secondary" @click="commodityInformationEntry(5)" v-if="isAuth(742)">
        {{ $t("message.productWeightEntry") }}
      </el-button>
      <!-- 客户页面链接 -->
      <el-button size="mini" type="primary" class="fr"
        @click="copy('https://www.rakumart.com/OrderDetails?order_sn=' + order_sn)">
        {{ $t("message.userLink") }}
      </el-button>
      <!-- 售中问题产品 -->
      <el-button size="mini" type="primary" class="fr" @click="issueSubmissionDuringSale" v-if="isAuth(171)">
        {{ $t("message.issueSubmissionDuringSale") }}
      </el-button>
      <!-- 提出问题产品 -->
      <el-button size="mini" type="primary" class="fr" @click="askAQuestionAboutTheProduct" v-if="isAuth(171)">
        {{ $t("message.askAQuestionAboutTheProduct") }}
      </el-button>
    </div>
    <!-- 追加商品表单 -->
    <addGoods :isUser_id="true" ref="addGoods" />
    <!-- 交易号拆分 -->
    <transactionNumberSplit v-if="transactionNumberSplitDialogVisible" :list="selectedList" />
    <!-- 交易号修改 -->
    <updatePurchase v-if="updatePurchaseDialogVisible" :ids="selectedIDs" />
    <!-- 物流号添加 -->
    <addExpress v-if="addExpressDialogVisible" :ids="selectedIDs" />
    <!-- 物流号删除 -->
    <deleteExpress v-if="deleteExpressDialogVisible" :expressList="expressList" :ids="selectedIDs" />
    <!-- 物流号修改 -->
    <updateExpress v-if="updateExpressDialogVisible" :expressList="expressList" :ids="selectedIDs" />
    <!-- 新增服务单 -->
    <addServiceOrder ref="addServiceOrder" />
    <!-- 新增服务单 -->
    <createServiceOrder ref="createServiceOrder" :user-role="role" />
    <!-- 监控商品 -->
    <monitorProductSettings ref="monitorProductSettings" :checkedList="checkedList" />
    <!--  问题产品-->
    <problemStore />
    <!-- 售中问题产品 -->
    <inSalePreview ref="inSalePreview" />
    <!-- 紧急问题 -->
    <urgent ref="urgent" />
    <!-- 预设任务 -->
    <presetTask ref="presetTask" />
    <!-- 配货商品信息录入表单 -->
    <deliveryPreview ref="deliveryPreview" />
    <!-- 服务单商品信息录入表单 -->
    <businessPreview ref="businessPreview" />
  </div>
</template>
<script>
import addGoods from "../components/addGoods";
import transactionNumberSplit from "../components/transactionNumberSplit";
import updatePurchase from "../components/updatePurchase";
import addExpress from "../components/addExpress";
import deleteExpress from "../components/deleteExpress";
import updateExpress from "../components/updateExpress";
import addServiceOrder from '../../porderDetail/components/packing/addServiceOrder'
import monitorProductSettings from "../components/monitorProductSettings";
import problemStore from "@/components/problemStore/store/index.vue";
import inSalePreview from '@/components/inSale/inSalePreview'
import urgent from '@/components/common/urgent'
import presetTask from '@/components/presetTask/index'
import createServiceOrder from '../components/createServiceOrder.vue'
import deliveryPreview from './deliveryPreview'
import businessPreview from './businessPreview'
export default {
  props: {
    detail: { type: Object },
    materialSaving: { type: Boolean, default: false },
    appendingOrderLastFour: { type: Boolean, default: false },
    markMaterialDisabled: { type: Boolean, default: false },
    bindMaterialDisabled: { type: Boolean, default: false }
  },
  data() {
    return {
      show: false,
      selectedList: [],
      selectedIDs: [],
      checkedList: [],
      checked: false,
      order_sn: this.$route.query.order_sn, //订单号
      transactionNumberSplitDialogVisible: false, //交易号拆分显示
      updatePurchaseDialogVisible: false, //交易号修改
      addExpressDialogVisible: false, //物流号添加
      deleteExpressDialogVisible: false, //物流号删除
      updateExpressDialogVisible: false, //修改物流号
      modalObserver: null, // 监听弹窗变化的观察者
      role: localStorage.getItem('japanUserRoleStatus'), //工种
    };
  },
  components: {
    addGoods,
    transactionNumberSplit,
    updatePurchase,
    addExpress,
    deleteExpress,
    updateExpress,
    addServiceOrder,
    monitorProductSettings,
    problemStore,
    inSalePreview,
    urgent,
    presetTask,
    createServiceOrder,
    deliveryPreview,
    businessPreview
  },
  mounted() {
    // 初始化
    this.observeModalChanges();
  },
  beforeDestroy() {
    // 清理资源
    this.destroyObserver();
  },

  methods: {
    handleTagOperation(command) {
      this.$emit('tag-operation', command)
    },
    handleMaterialOperation(command) {
      this.$emit('material-operation', command)
    },
    // 交易号/物流号下拉菜单只负责分发，具体校验和弹窗逻辑沿用原方法。
    handleTransactionLogisticsOperation(command) {
      const operationMap = {
        'transaction-split': 'transactionNumberSplit',
        'transaction-update': 'updatePurchase',
        'logistics-add': 'addExpress',
        'logistics-update': 'updateExpress',
        'logistics-delete': 'deleteExpress'
      }
      const operation = operationMap[command]
      if (operation) this[operation]()
    },
    // 选中的商品id
    selected() {
      this.selectedList = [];
      this.selectedIDs = [];
      this.detail.order_detail.forEach((item) => {
        item.order_purchase.forEach((items) => {
          if (items.checked) {
            items.detail = item.detail;
            items.pic = item.pic;
            items.newNum = 1;
            this.selectedList.push(items);
            this.selectedIDs.push(items.id);
          }
        });
      });
      this.$forceUpdate();
    },
    // 是否全选
    isAllChecked() {
      let flag = this.detail.order_detail.every((item) => item.checked);
      this.checked = flag;
      this.selected()

      this.$forceUpdate();
    },
    //  全选
    allChecked() {
      this.detail.order_detail.forEach((item) => {
        item.checked = this.checked;
        item.order_purchase.forEach((items) => {
          items.checked = this.checked;
        });
      });
      this.selected()
      this.$parent.selected()
    },

    //再来一单：复制商品时一并带上辅料标识和辅料绑定列表
    raiseAnotherOrder() {
      const sourceList = this.detail.order_detail.filter(item => item.checked)
      const orderDetailIds = sourceList.map(item => item.id)
      if (!orderDetailIds.length) return this.$message.error(this.$t('message.selectableOperationalList'))

      this.$api.orderApi.copyOrder({
        user_id: this.detail.user_id,
        order_sn: this.order_sn,
        order_detail_id: orderDetailIds
      }).then(res => {
        const orderList = res.data.order_data.reduce((goods, order) => goods.concat(order.goods), [])
        orderList.forEach((goods, index) => {
          const source = sourceList[index]
          if (!source) return
          const isMaterial = Number(source.is_material) === 1 || source.is_material === true
          const materialId = isMaterial
            ? (source.material_id || (source.material && source.material.id) || '')
            : ''
          goods.is_material = isMaterial
          goods.material_id = materialId
          goods.material = isMaterial ? (source.material || null) : null
          goods.material_detail = isMaterial ? (source.material_detail || source.material || null) : null
          goods.material_bind = Array.isArray(source.material_bind)
            ? JSON.parse(JSON.stringify(source.material_bind))
            : []
        })
        let routeUrl = this.$router.resolve({
          path: "/orderPreview?userID=" + this.detail.user_id + "&type=raiseAnotherOrder",
        });
        let data = {
          orderList,
          y_reply: this.detail.y_reply,
          y_remark: this.detail.y_remark,
        }
        window.open(routeUrl.href, JSON.stringify(data));
      })
    },
    //新增商品
    placeANewOrder() {
      this.$refs.addGoods.dialogVisible = true
      this.$refs.addGoods.setData(
        this.detail.user.id,
        this.detail.user.realname,
      )
    },
    //复制选择商品信息
    copyText() {
      let list = []
      this.detail.order_detail.forEach((item) => {
        if (item.checked) {
          list.push(item);
        }
      });
      if (list.length === 0) {
        this.$message.error(this.$t("message.pleaseSelectAtLeastOne")); //请至少选中一项
        return;
      }
      let copyUrl = "";
      list.forEach((item) => {
        let size = "";
        if (item.detail_y != null) {
          item.detail_y.forEach((items) => {
            size += items.key + ":" + items.value + "  ";
          });
        }
        let order_purchase = ''
        item.order_purchase.forEach(items => {
          order_purchase += `交易号：${items.purchase_no}\n`
        })

        if (this.userRole) {//是否是采购
          copyUrl += `${size} \n数量: ${item.offer_num_bak}\n订单番号:${this.order_sn}\n商品番号:${item.sorting}\n链接:${item.link}\n${order_purchase}`;
        } else {
          copyUrl += `${this.order_sn}\n${item.sorting}番  ${item.link}\n${order_purchase}`;
        }
      });
      //每一行的数据
      this.copy(copyUrl)
    },
    //加入商品库
    inventoryBatchSave() {
      let datas = {
        user_id: this.detail.user_id,
        data: []
      }
      this.detail.order_detail.forEach((item) => {
        if (item.checked) {
          item.shop_type = item.from_platform
          item.img_url = item.pic
          datas.data.push({
            shop_type: item.from_platform,
            img_url: item.pic,
            shop_id: item.shop_id,
            goods_id: item.goods_id,
            num: item.num,
            price: item.price,
            sku_id: item.sku_id,
            spec_id: item.spec_id,
            shop_name: item.shop_name,
            goods_title: item.goods_title,
            detail: JSON.stringify(item.detail),
            option: JSON.stringify(item.option),
            note: '',
            for_sn: '',
            detail_edit: '',
            copy_from_id: '',
          });
        }
      });
      if (datas.data == false) return this.$message.error('请选择商品')
      this.$api.clienteleApi.inventoryBatchSave(datas).then(res => {
        this.$message.success(res.msg)
      })
    },
    // 按订单详情 ID 创建商品管理数据，多个选中商品逐个提交且去重。
    async createProductManagement() {
      this.selected()
      if (this.selectedList == false) {
        return this.$message.error(this.$t("message.selectableOperational"))
      }
      const orderDetailIds = [...new Set(this.selectedList
        .map(item => Number(item.order_detail_id))
        .filter(id => Number.isInteger(id) && id > 0))]
      if (!orderDetailIds.length) {
        return this.$message.error('选中的商品缺少订单详情ID')
      }
      try {
        for (const order_detail_id of orderDetailIds) {
          const res = await this.$api.productManagementApi.createFromOrderDetail({ order_detail_id })
          if (res && (res.success === false || (res.code !== undefined && res.code != 0))) {
            throw new Error(res.msg || '加入商品管理失败')
          }
        }
        this.$message.success(this.$t('message.joinProductManagementSuccess'))
        this.orderDetails()
      } catch (error) {
        this.$message.error(error.message || this.$t('message.joinProductManagementFailed'))
      }
    },
    // 交易号拆分
    transactionNumberSplit() {
      this.selected();
      if (this.selectedList == false)
        return this.$message.error(this.$t("message.selectableOperational"));
      if (this.selectedList.length > 1)
        return this.$message.error("只能一个交易号拆分");
      this.transactionNumberSplitDialogVisible = true;
    },
    // 交易号修改
    updatePurchase() {
      this.selected();
      if (this.selectedList == false)
        return this.$message.error(this.$t("message.selectableOperational"));
      this.updatePurchaseDialogVisible = true;
    },
    //物流号添加
    addExpress() {
      this.selected();
      if (this.selectedList == false)
        return this.$message.error(this.$t("message.selectableOperational"));
      this.addExpressDialogVisible = true;
    },
    //物流号删除
    deleteExpress() {
      this.selected();
      if (this.selectedList == false)
        return this.$message.error(this.$t("message.selectableOperational"));
      this.expressList = this.getSelectedExpressList();
      if (this.expressList == false)
        return this.$message.error("无可以删除的物流号");
      this.deleteExpressDialogVisible = true;
    },
    // 物流修改
    updateExpress() {
      this.selected();
      if (this.selectedList == false)
        return this.$message.error(this.$t("message.selectableOperational"));
      this.expressList = this.getSelectedExpressList();
      if (this.expressList == false)
        return this.$message.error("无可以修改的物流号");
      this.updateExpressDialogVisible = true;
    },
    getSelectedExpressList() {
      let expressList = [];
      this.selectedList.forEach((item) => {
        if (Array.isArray(item.order_purchase_express) && item.order_purchase_express.length > 0) {
          item.order_purchase_express.forEach((express) => {
            expressList.push({
              ...express,
              order_purchase_id: item.id,
              purchase_no: item.purchase_no,
            });
          });
        }
      });
      return expressList;
    },
    // 物流号操作成功
    wuliuSuccess() {
      this.addExpressDialogVisible = false; //物流号添加
      this.deleteExpressDialogVisible = false; //物流号删除
      this.updateExpressDialogVisible = false; //修改物流号
      this.orderDetails();
    },
    //售中问题提出
    issueSubmissionDuringSale() {
      let ids = []
      this.detail.order_detail.forEach((item) => {
        if (item.checked) {
          ids.push(item.id)
        }
      });
      if (this.ids == false)
        return this.$message.error(this.$t("message.selectableOperational"));
      this.$refs.inSalePreview.storePreview(ids)
    },
    // 提出问题产品
    askAQuestionAboutTheProduct() {
      let order_purchase_id = [];
      this.detail.order_detail.forEach((item) => {
        item.order_purchase.forEach((items) => {
          if (items.checked) {
            order_purchase_id.push(items.id);
          }
        });
      });
      if (order_purchase_id == false) return this.$message.error(this.$t('message.selectableOperational'))
      this.show = true
      this.$store.dispatch("getProblemList", { order_purchase_id, inspect_detail_id: [] });
    },
    //问题产品提交成功
    problemStoreSuccess() {
      this.orderDetails();
    },
    //商品监控
    commodityMonitoringEntry() {
      this.checkedList = []
      this.detail.order_detail.forEach((item) => {
        if (item.checked) {
          this.checkedList.push(item)
        }
      });
      if (this.checkedList == false)
        return this.$message.error(this.$t("message.selectableOperational"));
      this.$refs.monitorProductSettings.dialogVisible = true
    },
    //新增服务单
    addServiceOrder() {
      this.selected()
      if (this.selectedList == false)
        return this.$message.error(this.$t("message.selectableOperational"));
      let datas = {
        order_sn: this.order_sn,
        order_detail_ids: []
      }
      this.selectedList.forEach(item => {
        datas.order_detail_ids.push(item.order_detail_id)
      })
      this.$refs.createServiceOrder.optionServicePreview(datas)
      this.$refs.createServiceOrder.dialogVisible = true
    },
    // 同店铺商品
    sameShop() {
      let list = [];
      this.detail.order_detail.forEach((item) => {
        if (item.checked) {
          list.push(item);
        }
      });
      list.forEach((item) => {
        this.detail.order_detail.forEach((items) => {
          if (item.shop_id == items.shop_id) {
            items.checked = true;
            items.order_purchase.forEach((itemss) => {
              itemss.checked = true;
            });
          }
        });
      });
      this.$forceUpdate();
    },
    // 同ID商品
    sameID() {
      let list = [];
      this.detail.order_detail.forEach((item) => {
        if (item.checked) {
          list.push(item);
        }
      });
      list.forEach((item) => {
        this.detail.order_detail.forEach((items) => {
          if (item.goods_id == items.goods_id) {
            items.checked = true;
            items.order_purchase.forEach((itemss) => {
              itemss.checked = true;
            });
          }
        });
      });
      this.$forceUpdate();
    },
    //新增紧急件
    newEmergency() {
      this.$refs.urgent.dalogVisible = true
    },
    // 设置备注
    setRemark(item) {
      this.itemDetail = JSON.parse(JSON.stringify(item))
      this.$refs.setRemarks.dialogVisible = true
    },
    // 订单详情
    orderDetails() {
      this.$parent.orderDetails()
    },

    // 监听body中.v-modal元素的变化
    observeModalChanges() {
      // 创建MutationObserver实例
      this.modalObserver = new MutationObserver((mutationsList) => {
        for (let mutation of mutationsList) {
          // 检查是否有新节点添加或移除
          if (mutation.type === 'childList') {
            // 检查body中是否存在.v-modal元素
            const modalElements = document.body.querySelectorAll('.v-modal');

            if (modalElements.length > 0) {
              this.show = true
              this.$forceUpdate()
              // console.log('模态框显示，找到.v-modal元素数量:', modalElements.length);
              // 可以在这里执行需要的操作
            } else {
              this.show = false
              // console.log('模态框隐藏，没有找到.v-modal元素');
              // 可以在这里执行需要的操作
            }
          }
        }
      });

      // 配置观察选项
      const config = {
        childList: true,
        subtree: true
      };

      // 开始观察body节点
      this.modalObserver.observe(document.body, config);
    },

    // 清理监听器
    destroyObserver() {
      if (this.modalObserver) {
        this.modalObserver.disconnect();
        this.modalObserver = null;
      }
    },
    // 预设任务
    createPresetTask() {
      let ids = []

      this.detail.order_detail.forEach((item) => {
        if (item.checked) {
          ids.push(item.id)
        }
      });
      if (ids == false) return this.$message.error('请选择需要抽查的番后再预设任务。')
      this.$refs.presetTask.typeList = [1, 2,]
      this.$refs.presetTask.dialogVisible = true
      this.$refs.presetTask.ids = ids
    },
    // 创建成功并加入列表
    successPresetTask(data) {
      this.detail.order_detail.forEach(item => {
        if (item.checked) {
          item.preset_spot_list.push(data)
        }
      })
      this.$forceUpdate()
    },
    // 商品信息录入
    commodityInformationEntry(role) {
      let selectedList = []
      this.detail.order_detail.forEach((item) => {
        if (item.checked) {
          let itemData = JSON.parse(JSON.stringify(item))

          selectedList.push(itemData)
        }
      });
      if (selectedList == false) return this.$message.error(this.$t('message.selectableOperationalList'))
      if (role == '1') {
        this.$refs.businessPreview.datas = {
          order_sn: this.order_sn,
          order_detail_ids: selectedList.map(item => item.id)
        }
        this.$refs.businessPreview.selectedList = selectedList
        this.$refs.businessPreview.businessPreview()
      } else if (role == '5') {
        this.$refs.deliveryPreview.datas = {
          order_sn: this.order_sn,
          order_detail_ids: selectedList.map(item => item.id)
        }
        this.$refs.deliveryPreview.selectedList = selectedList
        this.$refs.deliveryPreview.deliveryPreview()
      }


    },
    // 商品信息录入刷新
    refresh() {
      this.orderDetails()
    }
  }
}
</script>

<style lang='scss'>
.operate {
  position: sticky;
  bottom: 0;
  left: 0;
  // 弹窗打开时该类会移到按钮内层，避免根节点形成层叠上下文并被遮罩覆盖。
  z-index: 210;
  width: 100%;
  box-sizing: border-box;
  padding: 16px 24px;
  background: #edeff4;
  border-radius: 0px 0px 8px 8px;

  .el-button {
    padding: 7px 8px;
    margin-left: 5px;
  }

}
</style>
